import MembershipDetailDependentsList from ".";
import {
  IdentityDocumentType,
  MembershipStatus,
  MembershipType,
} from "../../../../services/core-api-adapter";

export default function MembershipDetailDependentsListExamples() {
  return (
    <>
      <MembershipDetailDependentsList
        dependents={[
          {
            isPrimaryCard: true,
            membershipDetails: {
              id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
              type: MembershipType.MAIN_MEMBER,
              number: "UNU-725",
              status: MembershipStatus.ACTIVE,
              beneficiaryCode: "00",
            },
            memberDetails: {
              id: "00000000-0000-4000-8000-000000000004",
              memberFullName: "Susan Persona",
              identityDocumentType: IdentityDocumentType.IdNumber,
              identityDocumentValue: "MOCK0005",
              dateOfBirth: "1966-05-19",
            },
          },
          {
            isPrimaryCard: true,
            membershipDetails: {
              id: "5a9e9e18-9142-44a9-8d85-0dc21759c5f0",
              type: MembershipType.MAIN_MEMBER,
              number: "UNU-725",
              status: MembershipStatus.ACTIVE,
              beneficiaryCode: "00",
            },
            memberDetails: {
              id: "00000000-0000-4000-8000-000000000004",
              memberFullName: "Susan Persona",
              identityDocumentType: null,
              identityDocumentValue: null,
              dateOfBirth: "1966-05-19",
            },
          },
        ]}
      />
    </>
  );
}
